import $ from 'jquery'
import { toolkitUrls } from '@/links'
import { getHandleRequest, getCSRFHeaders } from './request_handler'

export {
  getStudents,
  getStudentResources,
  copyCollection,
  getSharedStudent,
  deleteStudentResource,
  getLibraryCountForGoal,
  getLibraryCountForStrategy,
  getRecentStudents,
  addGoalForStudent,
  postStudentContent,
  deleteSavedGoalForStudent,
  deleteSavedStrategyForStudent,
  deleteStudent,
  addStudent,
  updateStudent,
  getLibraryGoal,
  getSharedGoal,
  saveGoalForStudent,
  getSavedStrategy,
  putSavedStrategy,
  addStrategyForStudent,
  getAllResourcesForContentTypes
}

function getStudentsRequest(userUuid) {
  const url = `${toolkitUrls.api}/collections/customresources/${userUuid}/students`

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: getCSRFHeaders()
  })
}

function getStudents(userUuid) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: getStudentsRequest}, userUuid)
}

async function getStudentResourcesRequest(studentUuid, params = {}) {
  const queryString = new URLSearchParams(params).toString()
  const url = `${toolkitUrls.api}/collections/${studentUuid}?${queryString}`
  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: getCSRFHeaders()
  })
}

async function getStudentResources(uuid, params = {}) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: getStudentResourcesRequest}, uuid, params)
}

function copyCollectionRequest(studentUuid, nameOfCopy) {
  const url = `${toolkitUrls.api}/collections/${studentUuid}/copy`

  return fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: getCSRFHeaders(),
    body: JSON.stringify({ name_of_copy: nameOfCopy })
  })
}

async function copyCollection(studentUuid, nameOfCopy) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: copyCollectionRequest}, studentUuid, nameOfCopy)
}

function getSharedStudent(shareToken, params = {}) {
  return $.ajax({
    url: `${toolkitUrls.api}/collections/share/${shareToken}?${$.param(params)}`,
    method: 'GET'
  })
}

function deleteStudentResourceRequest(studentUuid, contentUuid, resourceType) {
  const url = `${toolkitUrls.api}/collections/${studentUuid}/${contentUuid}/${resourceType}`

  return fetch(url, {
    method: 'DELETE',
    credentials: 'include',
    headers: getCSRFHeaders()
  })
}

async function deleteStudentResource(uuid, contentUuid, resourceType) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: deleteStudentResourceRequest}, uuid, contentUuid, resourceType)
}

async function getLibraryGoal(contentUuid, params = {}) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: getLibraryGoalRequest}, contentUuid, params)
}

function getLibraryGoalRequest(contentUuid, params = {}) {
  const queryString = new URLSearchParams(params).toString()
  const url = `${toolkitUrls.api}/library/goal/${contentUuid}?${queryString}`

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: getCSRFHeaders()
  })
}

function getSharedGoal(contentUuid, params = {}) {
  var target = `${toolkitUrls.api}/library/shared/goal/${contentUuid}?${$.param(params)}`
  return $.ajax({
    url: target,
    method: 'GET',
    xhrFields: { withCredentials: true }
  })
}

// TODO?: route needs to be updated to use collections in backend
function getLibraryCountForGoal(userUuid, goalUuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/${userUuid}/count/${goalUuid}`,
    method: 'GET',
    xhrFields: { withCredentials: true }
  })
}

function getLibraryCountForStrategy(userUuid, strategyUuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/${userUuid}/source_strategy/${strategyUuid}`,
    method: 'GET',
    xhrFields: { withCredentials: true }
  })
}

function getRecentStudentsRequest(userUuid, includeShared = false) {
  const params = new URLSearchParams({ include_shared: includeShared }).toString()
  const url = `${toolkitUrls.api}/library/${userUuid}/recent_students?${params}`
  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: getCSRFHeaders()
  })
}

function getRecentStudents(userUuid, includeShared = false) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: getRecentStudentsRequest}, userUuid, includeShared)
}

function addGoalForStudentRequest(student, goalPayload) {
  const url = `${toolkitUrls.api}/library/goal`
  const payload = {
    ...goalPayload,
    student_uuid: student.uuid,
    student_name: student.name,
    for_student: true
  }

  return fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: getCSRFHeaders(),
    body: JSON.stringify(payload)
  })
}

function addGoalForStudent(student, goalPayload) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: addGoalForStudentRequest}, student, goalPayload)
}

function saveGoalForStudentRequest(savedGoalUuid, goalPayload) {
  return fetch(`${toolkitUrls.api}/library/goal/${savedGoalUuid}`, {
    method: 'PUT',
    credentials: 'include',
    headers: getCSRFHeaders(),
    body: JSON.stringify(goalPayload)
  })
}

function saveGoalForStudent(savedGoalUuid, goalPayload) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: saveGoalForStudentRequest}, savedGoalUuid, goalPayload)
}

function getSavedStrategy(uuid) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: getSavedStrategyRequest}, uuid)
}

function getSavedStrategyRequest(uuid) {
  const url = `${toolkitUrls.api}/library/strategy/${uuid}`
  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: getCSRFHeaders()
  })
}

function putSavedStrategyRequest(savedStrategy) {
  const url = `${toolkitUrls.api}/library/strategy/${savedStrategy.uuid}`
  return fetch(url, {
    method: 'PUT',
    credentials: 'include',
    headers: getCSRFHeaders(),
    body: JSON.stringify(savedStrategy)
  })
}

function putSavedStrategy(savedStrategy) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: putSavedStrategyRequest}, savedStrategy)
}

function addStrategyForStudentRequest({ userUuid, strategyUuid, studentUuid, studentName, notes }) {
  const url = `${toolkitUrls.api}/library/strategy`

  const payload = {
    user_uuid: userUuid,
    strategy_uuid: strategyUuid,
    student_uuid: studentUuid,
    student_name: studentName,
    notes
  }

  return fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: getCSRFHeaders(),
    body: JSON.stringify(payload)
  })
}

function addStrategyForStudent({ userUuid, strategyUuid, studentUuid, studentName, notes }) {
  const handleRequest = getHandleRequest()
  return handleRequest(
    {requestFn: addStrategyForStudentRequest},
    { userUuid, strategyUuid, studentUuid, studentName, notes }
  )
}

function postStudentContentRequest(studentUuid, contentType, contentUuid, contributorUuid) {
  const url = `${toolkitUrls.api}/collections/content/add`

  return fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: getCSRFHeaders(),
    body: JSON.stringify({
      collection_uuid: studentUuid,
      content_type: contentType,
      content_uuid: contentUuid,
      contributor: contributorUuid
    })
  })
}

function postStudentContent(studentUuid, contentType, contentUuid, contributorUuid) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: postStudentContentRequest}, studentUuid, contentType, contentUuid, contributorUuid)
}

function deleteSavedGoalForStudent(savedGoalUuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/goal/${savedGoalUuid}`,
    method: 'DELETE',
    xhrFields: { withCredentials: true }
  })
}

function deleteSavedStrategyForStudent(savedStrategyUuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/strategy/${savedStrategyUuid}`,
    method: 'DELETE',
    xhrFields: { withCredentials: true }
  })
}

function deleteStudentRequest(studentUuid, userUuid) {
  const url = `${toolkitUrls.api}/library/${userUuid}/student/${studentUuid}`

  return fetch(url, {
    method: 'DELETE',
    credentials: 'include',
    headers: getCSRFHeaders()
  })
}

function deleteStudent(studentUuid, userUuid) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: deleteStudentRequest}, studentUuid, userUuid)
}

function addStudentRequest(studentName, userUuid) {
  const url = `${toolkitUrls.api}/library/${userUuid}/student`

  return fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: getCSRFHeaders(),
    body: JSON.stringify({ name: studentName })
  })
}

function addStudent(studentName, userUuid) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: addStudentRequest}, studentName, userUuid, )
}

function updateStudentRequest({ userUuid, studentUuid, updateParams }) {
  const url = `${toolkitUrls.api}/library/${userUuid}/student/${studentUuid}`

  return fetch(url, {
    method: 'PUT',
    credentials: 'include',
    headers: getCSRFHeaders(),
    body: JSON.stringify(updateParams)
  })
}

function updateStudent({ userUuid, studentUuid, updateParams }) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: updateStudentRequest}, { userUuid, studentUuid, updateParams })
}

function getAllResourcesForContentTypes(userUuid, contentTypes, includeShared = false) {
  contentTypes = encodeURIComponent(contentTypes.join(','))
  const params = new URLSearchParams({ include_shared: includeShared }).toString()
  return $.ajax({
    url: `${toolkitUrls.api}/library/${userUuid}/allresources/${contentTypes}?${params}`,
    method: 'GET',
    xhrFields: { withCredentials: true }
  })
}
